
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliate-terms",
      function () {
        return require("private-next-pages/affiliate-terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliate-terms"])
      });
    }
  